import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.updatePositions();
    });

    setTimeout(() => {
      this.updatePositions();
    }, 50);
  }

  moveUp(event) {
    event.preventDefault();
    event.stopPropagation();

    const card = event.currentTarget.closest(".key-question-item");
    if (!card) return;

    const cards = [...this.element.children].filter((el) =>
      el.classList.contains("key-question-item")
    );

    const index = cards.indexOf(card);

    if (index <= 0) return;

    this.element.insertBefore(card, cards[index - 1]);

    this.updatePositions();
    // this.scrollToCard(cards[index - 1]);
  }

  moveDown(event) {
    event.preventDefault();
    event.stopPropagation();

    const card = event.currentTarget.closest(".key-question-item");
    if (!card) return;

    const cards = [...this.element.children].filter((el) =>
      el.classList.contains("key-question-item")
    );

    const index = cards.indexOf(card);

    if (index === -1 || index >= cards.length - 1) return;

    const nextCard = cards[index + 1];

    this.element.insertBefore(nextCard, card);

    this.updatePositions();
    // this.scrollToCard(nextCard);
  }

  scrollToCard(card) {
    card.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }

  updatePositions() {
    const cards = [...this.element.querySelectorAll(".key-question-item")];

    console.log("Updating positions for cards:", cards.length);

    cards.forEach((card, index) => {
      const position = index + 1;

      const positionInput = card.querySelector(".position");
      if (positionInput) {
        positionInput.value = position;
      }

      const badge = card.querySelector(".question-index-badge");
      if (badge) {
        badge.innerHTML = `
				<i class="fa-solid fa-hashtag"></i>
				${position}
			`;
      }

      const upButton = card.querySelector(
        '[data-key-question-sortable-target="upButton"]'
      );

      const downButton = card.querySelector(
        '[data-key-question-sortable-target="downButton"]'
      );

      if (upButton) {
        upButton.disabled = index === 0;
      }

      if (downButton) {
        downButton.disabled = index === cards.length - 1;
      }
    });
  }
}
